import api from "./api";

/**
 * Initiates a registration request to search for a copay card.
 * @param {string|number} opportunityRef - The opportunity reference ID.
 * @returns {Promise<Object>} The registration request response.
 */
export const requestCopayCard = async (opportunityRef, payload = {}) => {
  try {
    const response = await api.post(
      `/api/aedificare/registration-request/${opportunityRef}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("requestCopayCard failed:", error);
    throw error;
  }
};

/**
 * Polls status of a registration request.
 * @param {string|number} id - The registration request ID.
 * @returns {Promise<Object>} The registration request status response.
 */
export const pollCopayCardStatus = async (id) => {
  try {
    const response = await api.get(
      `/api/aedificare/registration-request/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("pollCopayCardStatus failed:", error);
    throw error;
  }
};

/**
 * Submits manual copay card details to the server.
 * @param {string|number} opportunityRef - The opportunity reference ID.
 * @param {Object} payload - The manual card details.
 * @returns {Promise<Object>} The response.
 */
export const submitManualCopayCard = async (opportunityRef, payload) => {
  try {
    const response = await api.post(
      `/api/aedificare/registration-request/${opportunityRef}/manual`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("submitManualCopayCard failed:", error);
    throw error;
  }
};

